<kendo-appbar class="appbar" [class.appbar--non-prod]="showNonProdBanner" aria-live="assertive">
  <kendo-appbar-section class="title">
    <span *ngIf="showNonProdBanner" class="environment-banner-inline">
      NON-PRODUCTION ENVIRONMENT
      <span class="environment-banner-inline__separator">|</span>
      {{ nonProdEnvironmentLabel }}
    </span>
  </kendo-appbar-section>

  <kendo-appbar-spacer></kendo-appbar-spacer>

  <kendo-appbar-section *ngIf="isShowTopSearchBar()" class="search-section">
    <div (click)="openNewReferralModalHandler()" kendoTooltip title="Search student here"
      (keydown.enter)="openNewReferralModalHandler()">
      <kendo-label labelCssClass="hidden-label" text="Search for Student">
        <kendo-textbox class="search-container" placeholder="Search" [clearButton]="true" [readonly]="true">
          <ng-template kendoTextBoxPrefixTemplate>
            <kendo-dropdownlist aria-placeholder="Student" value="Student" [data]="['Student', 'Staff']"
              class="search-dropdown" size="large" rounded="large" [readonly]="true">
            </kendo-dropdownlist>
            <kendo-textbox-separator></kendo-textbox-separator>
          </ng-template>

          <ng-template kendoTextBoxSuffixTemplate>
            <div class="k-px-2">
              <button kendoButton [svgIcon]="searchIcon" size="small" themeColor="primary" fillMode="flat"></button>
            </div>
          </ng-template>
        </kendo-textbox>
      </kendo-label>
    </div>
  </kendo-appbar-section>

  <kendo-appbar-spacer width="24px"></kendo-appbar-spacer>
  <kendo-appbar-section class="user-actions" *ngIf="enableNotifications">
    <div class="notification-icon-wrapper">
      <div kendoPopoverAnchor [popover]="notificationInfo" showOn="none" #anchor="kendoPopoverAnchor">
        <kendo-badge-container>
          <button class="helpIcon" kendoButton (click)="togglePopover()" title="Recent Notifications" fillMode="flat"
            size="none">
            <fa-icon icon="bell" size="2x"></fa-icon>
          </button>
          <kendo-badge themeColor="error" size="medium" position="inside" rounded="full"
            *ngIf="badgeCountToShow" [align]="{ vertical: 'top', horizontal: 'end' }"></kendo-badge>
        </kendo-badge-container>
      </div>
    </div>
  </kendo-appbar-section>
  <kendo-appbar-section class="user-actions">
    <button class="helpIcon" kendoButton (click)="openHelp()" title="Help" fillMode="flat" size="none">
      <fa-icon icon="circle-question" size="2x"></fa-icon>
    </button>
  </kendo-appbar-section>
  <kendo-appbar-section class="user-actions">
    <button class="helpIcon" kendoButton (click)="openReleaseNotes()" title="Release Notes" fillMode="flat" size="none">
      <fa-icon icon="book" size="2x"></fa-icon>
    </button>
  </kendo-appbar-section>

  <kendo-appbar-section>
    <kendo-avatar initials="{{ user?.firstName?.charAt(0) }}{{ user?.lastName?.charAt(0) }}"
      size="medium"></kendo-avatar>
    <div class="user-info-container">
      <div class="user-name k-font-bold">
        <div>
          <div>{{ user?.firstName }} {{ user?.lastName }}</div>
          <div class="k-font-normal">
            {{
            user?.selectedRole?.roleDescription ||
            user?.selectedRole?.roleName
            }}
          </div>
        </div>
        <button kendoButton class="link-button logout-button" size="small" fillMode="link" themeColor="base"
          (click)="logout()">(Log Out)</button>
      </div>
    </div>
  </kendo-appbar-section>
</kendo-appbar>


<app-student-search [showSearchModal]="(showNewReferralModal$ | async)!" [newReferral]="isNewReferral"
  [showCreateStudentBtn]="true" (closeModal)="closeModalHandler()">
</app-student-search>

<kendo-popover #notificationInfo [width]="636" position="bottom" [callout]="false">
  <ng-template kendoPopoverTitleTemplate>
    <div>
      <h4>Recent Notifications</h4>
    </div>
  </ng-template>

  <ng-template kendoPopoverBodyTemplate>
    <div class="loading-container">
      <div class="loading-panel-mask"></div>
      <kendo-loader *ngIf="loadSpinner" type="converging-spinner"></kendo-loader>
    </div>
    <div class="popover-body">
      <kendo-tabstrip [tabAlignment]="alignment" size="large" (tabSelect)="onSelect($event)">
        <kendo-tabstrip-tab [selected]="true">
          <ng-template kendoTabTitle>
            <strong>Action Required</strong>
            <span class="tabstrip-count">{{actionRequiredLength}}</span>
          </ng-template>
          <ng-template kendoTabContent>
            <app-notification-content [content]="actionRequired"></app-notification-content>
          </ng-template>
        </kendo-tabstrip-tab>
        <kendo-tabstrip-tab [selected]="false">
          <ng-template kendoTabTitle>
            <strong>Informational</strong>
            <span class="tabstrip-count">{{informationalLength}}</span>
          </ng-template>
          <ng-template kendoTabContent>
            <app-notification-content [content]="informational"></app-notification-content>
          </ng-template>
        </kendo-tabstrip-tab>
      </kendo-tabstrip>
    </div>
  </ng-template>

  <ng-template kendoPopoverActionsTemplate>
    <div class="k-d-flex k-justify-conetent-start notification-actions">
      <button kendoButton fillMode="flat" themeColor="primary"
        *ngIf="(actionRequired?.length && selectedTabIndex === 0 || informational?.length && selectedTabIndex === 1)"
        (click)="markAllAsDone(selectedTabIndex)">
        {{selectedTabIndex === 0 ? 'Mark Above as Done' : 'Mark Above as Read'}}
      </button>
      <button kendoButton fillMode="flat" themeColor="primary" (click)="viewAllNotifications()">
        View All
      </button>
    </div>
  </ng-template>
</kendo-popover>